import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
// import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

export async function UploadImageToS3(props, guid) {
  // console.log("UploadImageToS3", "image", props, "guid", guid);
  const REGION = "eu-central-1";
  const s3 = new S3Client({
    region: REGION,
    credentials: {
      accessKeyId: process.env.REACT_APP_AWS_API_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_API_SECRET,
    },
  });

  // console.log("s3", JSON.stringify(s3, null, 2));
  const file = props;

  const params = {
    Bucket: "decorate-input",
    Key: `${guid}/input_image`,
    Body: file,
  };
  console.log(params);
  const command = new PutObjectCommand(params);

  try {
    const data = await s3.send(command);
    console.log("Success:", data);
    return data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
}
